import { useState, useRef } from "react";
import { useOnClickOutside } from "hooks/ClickOutside";
import "./Tooltip.css";
import { IUser } from "authentication/domain/IUser";

type ToolTipProps = {
  className?: string;
  className1?: string;
  style: object;
  arrowStyle?: object;
  children: Function;
  content: Function;
  delay: number;
  direction: string;
  currentUser?: IUser;
  title?: string;
  clear?: () => void;
};

export interface IToolTipContentProps {
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
  currentUser: IUser;
  hideTip: () => void;
}

const Tooltip = (props: ToolTipProps) => {
  let className = props.className || "Tooltip-Wrapper";
  let timeout: NodeJS.Timeout;
  const [active, setActive] = useState(false);
  const [clickOutsideActive, setClickOutsideActive] = useState(true);

  const ref = useRef<HTMLDivElement>(null);
  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 400);
  };

  const hideTip = () => {
    if (props.clear) {
      props.clear();
    }
    clearInterval(timeout);
    if (clickOutsideActive) {
      setActive(false);
    }
  };

  useOnClickOutside(ref, hideTip);

  return (
    <div className={`${className}`}>
      {/* Wrapping */}
      {props.children(showTip)}
      {active && (
        <div
          ref={ref}
          style={props.style}
          className={`Tooltip-Tip ${props.direction || "top"} ${props.className1 || ""
            }`}
        >
          <div className="tooltip-header">{props.title}</div>
          <div className="arrow" style={props.arrowStyle} />
          <div className="tooltip-content">
            {props.content({
              setClickOutsideActive,
              currentUser: props.currentUser,
              hideTip,
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
